// SETTINGS V2 — one region row inside the Standard / Express dialog tabs
// (SETTINGS_V2_SP9 §3). Designer DlgShipping row() (settings-pages-c.jsx 147-155):
// grid `24px 1fr 110px 110px 110px` on desktop, stacked 1-col on phone. SCheck
// (isActive) + region label + min/max/price SInputField (mono number), disabled
// when inactive, per-field error slot. Inline styles + scoped CSS-var tokens +
// v2 atoms only — no MUI/sx/dt/Tailwind.
import React from "react";

import useTranslation from "../../../../shared/hooks/useTranslation";
import { SCheck, SInputField } from "../atoms";
import { Row } from "../pages/shippingV2Utils";

export interface ShippingRegionRowFieldErrors {
  from?: string;
  to?: string;
  price?: string;
}

export interface ShippingRegionRowV2Props {
  label: string;
  row: Row;
  errors: ShippingRegionRowFieldErrors;
  onToggle: (next: boolean) => void;
  onChange: (field: "from" | "to" | "price", value: string) => void;
  isPhone: boolean;
}

const ShippingRegionRowV2: React.FC<ShippingRegionRowV2Props> = ({
  label,
  row,
  errors,
  onToggle,
  onChange,
  isPhone,
}) => {
  const { translate: t } = useTranslation("settings");
  const on = row.isActive;

  const labelSpan = (
    <span
      style={{
        fontSize: 13,
        fontWeight: 500,
        color: on ? "var(--ink)" : "var(--faint)",
        paddingBottom: isPhone ? 0 : 10,
        minWidth: 0,
      }}
    >
      {label}
    </span>
  );

  const minField = (
    <SInputField
      label={t("settings:shipping.minDays")}
      type="number"
      mono
      value={row.from}
      onChange={(v) => onChange("from", v)}
      placeholder="—"
      disabled={!on}
      error={errors.from}
    />
  );
  const maxField = (
    <SInputField
      label={t("settings:shipping.maxDays")}
      type="number"
      mono
      value={row.to}
      onChange={(v) => onChange("to", v)}
      placeholder="—"
      disabled={!on}
      error={errors.to}
    />
  );
  const priceField = (
    <SInputField
      label={t("settings:costEuro")}
      type="number"
      mono
      value={row.price}
      onChange={(v) => onChange("price", v)}
      placeholder="—"
      disabled={!on}
      error={errors.price}
    />
  );

  if (isPhone) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          padding: "12px 0",
          borderTop: "1px solid var(--border-soft)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <SCheck on={on} onToggle={onToggle} label="" />
          {labelSpan}
        </div>
        {minField}
        {maxField}
        {priceField}
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "24px 1fr 110px 110px 110px",
        gap: 10,
        alignItems: "end",
        padding: "10px 0",
        borderTop: "1px solid var(--border-soft)",
      }}
    >
      <span style={{ paddingBottom: 10 }}>
        <SCheck on={on} onToggle={onToggle} label="" />
      </span>
      {labelSpan}
      {minField}
      {maxField}
      {priceField}
    </div>
  );
};

export default ShippingRegionRowV2;
